
import React from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface SuggestionsHeaderProps {
  isRefreshing: boolean;
  isDebugMode: boolean;
  fetchSuggestions: () => Promise<void>;
  toggleDebugMode: () => void;
}

const SuggestionsHeader: React.FC<SuggestionsHeaderProps> = ({
  isRefreshing,
  isDebugMode,
  fetchSuggestions,
  toggleDebugMode
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6 flex justify-between items-center">
      <div>
        <h2 className="text-xl font-semibold mb-2">{t('interview.suggestions')}</h2>
        <p className="text-gray-600">
          {t('interview.tipsDescription')}
        </p>
      </div>
      <div className="flex gap-2">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={fetchSuggestions}
          disabled={isRefreshing}
          className="flex items-center gap-1"
        >
          <RefreshCw className={`w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`} />
          {isRefreshing ? t('interview.refreshing') : t('interview.refresh')}
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={toggleDebugMode}
          className="hidden md:flex"
        >
          {isDebugMode ? t('interview.hideDebug') : t('interview.debug')}
        </Button>
      </div>
    </div>
  );
};

export default SuggestionsHeader;
